import { TicketAccess } from "./../../../models/TicketAccess";
import {
  GET_AVAILABLE_EXERCISE,
  GET_DAYS_AVAILABLE_BYNAME,
  GET_DAYS_AVAILABLE_PASSIDS,
  GET_EXERCISE_BY_DATE_AND_NAME,
  GET_EXERCISE_BY_PASSID,
  GET_SCHEDULE_DETAILS,
  GET_TICKET_BY_EXERCISE,
  JOIN_TO_EXERCISE,
} from "./../../../api/apiRoutes";
import { Assort } from "../../../models/Assort";
import { Exercise } from "../../../models/Exercise";
import { useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_EXERCISE_BY_DAY } from "../../../api/apiRoutes";
import { addDays, format, eachDayOfInterval } from "date-fns";
import { setTicketAccessFromExercise } from "../../../models/TicketAccess";
import { CalendarDaysAvailable } from "../../../models/CalendarDaysAvailable";
import { post } from "../../../api";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { Identifiable } from "../../../models/Identifiable";
import getId from "../../../../utils/getId";
import { toUserErrorMessage } from "../../../utils/apiErrorMessages";

export default function useCalendarSale() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [exercise, setExercise] = useState<Exercise[]>([]);
  const [exerciseDetails, setExerciseDetails] = useState<Exercise>();
  const [exerciseAvailAble, setExerciseAvailAble] = useState<Exercise[]>([]);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [tickets, setTickets] = useState<Assort[]>([]);
  const [availableDays, setAvailableDays] = useState<CalendarDaysAvailable[]>([]);
  const [listaDat, setListaDat] = useState<any[]>([]);
  const [soldOutDates, setSoldOutDates] = useState<Date[]>([]);
  const [firstAvailableDate, setFirstAvailableDate] = useState<Date>(new Date());
  const [ticketLimit, setTicketLimit] = useState<number>(0);
  const [chooseTime, setChosenTime] = useState<number>(0);
  const [ticketAccess, setTicketAccess] = useState<TicketAccess>({} as TicketAccess);
  const [alertCalendar, setAlertCalendar] = useState<string>("");
  const [alerts, setAlerts] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState<boolean>(false);
  const userDataId = useSelector((state: State) => state.auth.userData.objectId);

  const toggleConfirmationModal = (isOpen: boolean) => {
    setIsConfirmationModalOpen(isOpen);
  };

  const joinToExercise = async (exerciseId: number, assigned: boolean, passId: string, onFinish: () => void) => {
    const { isError, errorTable } = await post(JOIN_TO_EXERCISE(facilityIds, passId), {
      exerciseIds: exerciseId,
      webUserIds: `0,${userDataId}`,
      assigned: assigned,
    });

    if (!isError) {
      onFinish();
      if (!assigned) {
        toggleConfirmationModal(true);
      }
    }
    if (isError) {
      setAlerts(toUserErrorMessage(errorTable));
    }
  };

  const getExercisesByDay = async (date: Date) => {
    setSelectedDate(date);
    setExercise([]);
    setTicketAccess({} as TicketAccess);
    setTickets([]);
    const formattedDate = format(date, "yyyy-MM-dd");
    const { result, isError } = await get(GET_EXERCISE_BY_DAY(facilityIds, formattedDate));
    if (!isError) {
      setExercise(result);
    }
  };

  const getTicketsByExercise = async (id: Identifiable, exercise: Exercise) => {
    const exerciseGroupIds = getId(id);
    let ticketAccessTransform = setTicketAccessFromExercise(
      exercise.objectId,
      exercise.name.replace(/%/g, "%25"),
      exercise.startTime
    );
    setTicketAccess(ticketAccessTransform);
    const { result, isError } = await get(GET_TICKET_BY_EXERCISE(facilityIds, exerciseGroupIds));
    if (!isError) {
      setTickets(result);
      setTicketLimit(exercise.capacity - (exercise.reserved + exercise.prereservation));
      setChosenTime(exercise.startTime);
    }
  };
  // DO poierania zajęć dostępnych 120 w przód.
  const getExercisesAvailable = async (nameParam?: string) => {
    setLoading(true);
    const formattedDateFrom = format(new Date(), "yyyy-MM-dd");
    const formattedDateTo = format(new Date(addDays(new Date(), 360)), "yyyy-MM-dd");

    const { result, isError } = await get(
      GET_AVAILABLE_EXERCISE(facilityIds, formattedDateFrom, formattedDateTo, nameParam)
    );
    if (!isError) {
      setExerciseAvailAble(result);
    }
    setLoading(false);
  };

  // Pobieranie dni dla konkretnej nazwy zajęć
  const getDaysAvailableByName = async (name: string) => {
    const formattedDateFrom = format(new Date(), "yyyy-MM-dd");
    const formattedDateTo = format(new Date(addDays(new Date(), 360)), "yyyy-MM-dd");
    if (facilityIds !== null) {
      const { result, isError } = await get(
        GET_DAYS_AVAILABLE_BYNAME(facilityIds, formattedDateFrom, formattedDateTo, name)
      );
      if (!isError) {
        setAvailableDays(result);

        // Generujemy pełny zakres dat od dateFrom do dateTo
        const startDate = new Date();
        const endDate = new Date(addDays(new Date(), 360));
        const allDatesInRange = eachDayOfInterval({ start: startDate, end: endDate });

        // Tworzymy Set z datami które zwróciło API (dla szybszego wyszukiwania)
        const apiDatesSet = new Set(result.map((item: any) => item.date));

        // Lista dat które nie są w odpowiedzi API (powinny być disabled)
        const missingDates = allDatesInRange.filter((date) => {
          const dateString = format(date, "yyyy-MM-dd");
          return !apiDatesSet.has(dateString);
        });

        // Lista dat, które są całkowicie niedostępne (np. wyłączone)
        const filterList = result.filter((item: any) => item.unavailable && item.partialUnavailable === false);
        const unavailableDates = filterList.map((item: any) => new Date(item.date));

        // Łączymy brakujące daty z niedostępnymi datami z API
        const allDisabledDates = [...missingDates, ...unavailableDates];
        setListaDat(allDisabledDates);

        // Lista dat, które były dostępne, ale zostały wyprzedane (sprzedane w całości)
        const soldOutList = result.filter((item: any) => item.unavailable === true && item.partialUnavailable === true);
        setSoldOutDates(soldOutList.map((item: any) => new Date(item.date)));

        // Ustawiamy datę pierwszej dostępnej, jeśli jest
        const filterAvailableDateList = result.filter((item: any) => item.unavailable === false);
        if (filterAvailableDateList.length > 0) {
          const findedDate = filterAvailableDateList[0].date;
          setFirstAvailableDate(new Date(findedDate));
        }
      }
    }
  };

  //Pobieranie dni dla konkretnej grupy zajęciowej przy zmianie terminu
  const getDaysAvailableByPassId = async (passIds: number) => {
    const formattedDateFrom = format(new Date(), "yyyy-MM-dd");
    const formattedDateTo = format(new Date(addDays(new Date(), 360)), "yyyy-MM-dd");
    const { result, isError } = await get(
      GET_DAYS_AVAILABLE_PASSIDS(facilityIds, formattedDateFrom, formattedDateTo, "0," + passIds)
    );
    if (!isError) {
      setAvailableDays(result);

      // Generujemy pełny zakres dat od dateFrom do dateTo
      const startDate = new Date();
      const endDate = new Date(addDays(new Date(), 360));
      const allDatesInRange = eachDayOfInterval({ start: startDate, end: endDate });

      // Tworzymy Set z datami które zwróciło API (dla szybszego wyszukiwania)
      const apiDatesSet = new Set(result.map((item: any) => item.date));

      // Lista dat które nie są w odpowiedzi API (powinny być disabled)
      const missingDates = allDatesInRange.filter((date) => {
        const dateString = format(date, "yyyy-MM-dd");
        return !apiDatesSet.has(dateString);
      });

      // Lista dat, które są niedostępne w API
      const filterList = result.filter((item: any) => item.unavailable);
      const unavailableDates = filterList.map((item: any) => new Date(item.date));

      // Łączymy brakujące daty z niedostępnymi datami z API
      const allDisabledDates = [...missingDates, ...unavailableDates];
      setListaDat(allDisabledDates);
    }
  };

  const getExercisesByPassIds = async (date: Date, passIds: string) => {
    setSelectedDate(date);
    const formattedDateFrom = format(date, "yyyy-MM-dd");
    const { result, isError } = await get(
      GET_EXERCISE_BY_PASSID(facilityIds, formattedDateFrom, formattedDateFrom, passIds)
    );
    if (!isError) {
      setExercise(result);
    }
  };

  const getHoursAvaiableByName = async (date: Date, name: string, preserveTicketAccess: boolean = false) => {
    setSelectedDate(date);

    // Preserve current ticketAccess if requested (e.g., during capacity refresh)
    const currentTicketAccess = preserveTicketAccess ? ticketAccess : null;

    // Only clear exercise list if NOT preserving (to avoid triggering useEffect that resets UI)
    if (!preserveTicketAccess) {
      setExercise([]);
      setTicketAccess({} as TicketAccess);
      setTickets([]);
    }

    const formattedDate = format(date, "yyyy-MM-dd");
    const { result, isError } = await get(
      GET_EXERCISE_BY_DATE_AND_NAME(facilityIds, formattedDate, name)
    );
    if (!isError) {
      setExercise(result);

      // If preserving ticketAccess and we have a saved one, restore it and refresh tickets
      if (preserveTicketAccess && currentTicketAccess?.exerciseIds) {
        setTicketAccess(currentTicketAccess);

        const matchingExercise = result.find((ex: Exercise) => String(ex.objectId) === currentTicketAccess.exerciseIds);

        if (matchingExercise) {
          const exerciseGroupIds = getId(matchingExercise.exerciseGroup);
          const { result: ticketsResult, isError: ticketsError } = await get(
            GET_TICKET_BY_EXERCISE(facilityIds, exerciseGroupIds)
          );
          if (!ticketsError) {
            setTickets(ticketsResult);
            setTicketLimit(matchingExercise.capacity - (matchingExercise.reserved + matchingExercise.prereservation));
            setChosenTime(matchingExercise.startTime);
          }
        }
      } else if (!preserveTicketAccess && result[0]) {
        let ticketAccessTransform = setTicketAccessFromExercise(
          result[0].objectId,
          result[0].name,
          result[0].startTime
        );
        setTicketAccess(ticketAccessTransform);
      }
    }
  };

  const getAssignByTicket = async (passdb: number, passId: number, exerciseIds: number, onSuccess?: () => void) => {
    const params = {
      // assigned: ;
      webUserIds: `0,${userDataId}`,
      exerciseIds: exerciseIds,
      assigned: false,
    };
    const { isError, errorTable } = await post(JOIN_TO_EXERCISE(facilityIds, `${passdb},${passId}`), params);
    if (!isError) {
      onSuccess && onSuccess();
    }
    if (isError) {
      setAlertCalendar(toUserErrorMessage(errorTable));
    }
  };
  const getDetailsAboutExercise = async (exerciseIds: number) => {
    const { result, isError } = await get(GET_SCHEDULE_DETAILS(facilityIds, `0,${exerciseIds}`, `0,${userDataId}`));
    if (!isError) {
      setExerciseDetails(result);
      setTimeout(() => {
        setAlertCalendar("");
      }, 2000);
    }
  };
  return {
    alerts,
    joinToExercise,
    exerciseDetails,
    getDetailsAboutExercise,
    alertCalendar,
    chooseTime,
    ticketLimit,
    getAssignByTicket,
    getExercisesByPassIds,
    getDaysAvailableByPassId,
    getHoursAvaiableByName,
    getDaysAvailableByName,
    availableDays,
    listaDat,
    getExercisesAvailable,
    exerciseAvailAble,
    getExercisesByDay,
    getTicketsByExercise,
    exercise,
    selectedDate,
    tickets,
    ticketAccess,
    firstAvailableDate,
    loading,
    soldOutDates,
    isConfirmationModalOpen,
    toggleConfirmationModal,
  };
}
